import LocalStorageService from '../services/local-storage.service';
import Env from '../config/env';

declare global {
  interface Window {
    tmxAddSessionId: (id: string, profile: string, orgId: string) => void;
  }
}

export const addSessionIdToTMX = (id: string) => {
  window.tmxAddSessionId(id, Env.TMX_PROFILE_DOMAIN, Env.TMX_ORD_ID);
  LocalStorageService.setItem('session', id);
};

export const getTMXSessionId = (): string => {
  const sessionId = LocalStorageService.getItem<string>('session') || '';
  window.tmxAddSessionId(sessionId, Env.TMX_PROFILE_DOMAIN, Env.TMX_ORD_ID);
  return sessionId;
};
